import { render, staticRenderFns } from "./AdDetails.vue?vue&type=template&id=3a85ec90&"
import script from "./AdDetails.vue?vue&type=script&lang=js&"
export * from "./AdDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports